import React from 'react'
import { ThemeProvider } from '@emotion/react'
import styled from '@emotion/styled'

import { MetaData } from '~/types/common.types'

import useTheme from '~/hooks/useTheme'

import TopBtn from './TopBtn'
import Header from './Header'
import Footer from './Footer'
import Head from '~/components/common/Head'

import GlobalStyle from '~/styles/GlobalStyle'

export type SEO = Partial<MetaData>
type Props = SEO & { noFooter?: boolean }

const Layout: React.FC<Props> = ({ noFooter = false, children, ...rest }) => {
  const { theme } = useTheme()

  return (
    <>
      <Head {...rest} />
      {/* TODO: theme type warning 수정 */}
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        <TopBtn />
        <Wrapper>
          <Header />
          <Main>{children}</Main>
          {!noFooter && <Footer />}
        </Wrapper>
      </ThemeProvider>
    </>
  )
}

const Wrapper = styled.div`
  height: 100%;
  padding: 0 ${({ theme: { padding } }) => padding.desktop}px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Main = styled.main`
  padding-top: ${({ theme: { height } }) => height.header}px;
  width: min(${({ theme: { width } }) => width.main}px, 100%);
  display: flex;
  flex-direction: column;
  flex: 1;
`

export default Layout
